import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

export const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  alignItems: 'flex-start',
  borderRadius: theme.spacing(2),
}));

export const StyledEmptyBox = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '230px',
  backgroundColor: theme.palette.background.hover,
  borderRadius: theme.spacing(2),
}));

export const ScheduleContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '230px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.hover,
  borderRadius: theme.spacing(2),
  gap: theme.spacing(1),
}));

export const ScheduleItemRow = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '3fr 2fr',
  alignItems: 'center',
  justifyItems: 'center',
  padding: '13px ',
  borderBottom: `1px solid ${theme.palette.divider || theme.colors.borderBottom}`,

  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const SubtitleText = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
}));

export const MissedText = styled(Typography)(({ theme }) => ({
  color: theme.colors.red,
}));
export const ComplementaryText = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
}));

export const ScheduleItemValue = styled(Box)(({ theme }) => ({
  width: 'auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.colors.blue,
  padding: theme.spacing(1, 2),
  backgroundColor: theme.colors.softGray,
  borderRadius: theme.spacing(1), // Usando theme.spacing para consistencia
}));
